<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>新增首页分类</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :model="categoryForm" ref="categoryForm">
            <el-form-item label="选择要显示的分类" label-width="150px" prop="catogrey">
                <el-select v-model="categoryForm.catogrey" placeholder="分类"  @change="catogreyChoose">
                    <el-option v-for="item in catogreyArr" v-if="item.isOnline" :key="item.categoryId" :label="item.name" :value="item.categoryId">
                    </el-option>
                </el-select>
            </el-form-item>
    
            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    
    </div>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        filterIndexVersions,
        getProductCategories,
        getProductTags,
        getProductDetails
    } from '../../api/version'
    
    export default {
        data() {
            return {
                categoryForm: {
                    catogrey: '',
                    product: ''
                },
                addShopRules: {
                    name: [{
                        required: true,
                        message: '请输入享玩甄选描述',
                        trigger: 'blur'
                    }],
                    shop: [{
                        type: 'number',
                        required: true,
                        message: '请选择商品',
                        trigger: 'blur'
                    }]
                },
                uptoken: {
                    token: sessionStorage.token
                },
                catogreyArr: [],
   
            }
        },
        created() {
            getProductCategories().then(res => {
                this.catogreyArr = res.data
                console.log(res.data)
                this.$store.commit('SETTOPICARR', this.catogreyArr);
            })
        },
        methods: {
            catogreyChoose(val){
                this.catogreyArr.forEach( (item) => {
                    if(item.categoryId === val) {
                        this.categoryForm.product = item
                    }
                })
            },
            goBack() {
                //取消
                this.$router.push('/indexCatogrey')
            },
            onSubmit() {
                if(this.categoryForm.product) {
                    let data = {
                        picUrl: this.categoryForm.product.picUrl,
                        targetId: this.categoryForm.product.categoryId,
                        name: this.categoryForm.product.name
                    }
                    let currentData = this.$store.state.currentIndex
                    currentData.value.category.push(data)
                    this.$store.commit('SETCURRENTINDEX', currentData);
                    this.$router.push('/indexCatogrey')
                }else{
                    this.$message.error('请选择分类');
                }
            },
        }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .el-upload-list {
        display: flex;
    }
    
    .el-upload-list--picture .el-upload-list__item {
        width: 300px;
        margin-right: 15px;
    }
</style>




// WEBPACK FOOTER //
// AddCategory.vue?0449f080